import React, { useState, useEffect } from 'react';
import { Field } from 'formik';
import { DatePicker } from 'equasion-lib';

// Touch-primary devices (phones, tablets) - not viewport-based
// Desktop with shrunken window still gets custom calendar
const TOUCH_DEVICE_MEDIA_QUERY = '(pointer: coarse)';

/**
 * On touch devices: uses native date input (iOS/Android picker only).
 * On desktop (mouse/trackpad): uses equasion-lib DatePicker with custom calendar popover.
 * Prevents both pickers from opening on touch devices.
 */
export default function MobileAwareDatePicker(props) {
  const [isTouchDevice, setIsTouchDevice] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(TOUCH_DEVICE_MEDIA_QUERY).matches : false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(TOUCH_DEVICE_MEDIA_QUERY);
    const handler = (e) => setIsTouchDevice(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  if (isTouchDevice) {
    return (
      <Field name={props.name}>
        {({ field, form, meta }) => {
          // Use local date for display (avoid UTC timezone shifting day)
          const d = field.value ? new Date(field.value) : new Date();
          const isoDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
          const hasError = meta.touched && meta.error;

          return (
            <div className={`eq-datepicker eq-datepicker--native ${hasError ? 'error' : ''}`}>
              {props.label && <label htmlFor={props.name}>{props.label}</label>}
              <input
                type="date"
                id={props.name}
                name={props.name}
                value={isoDate}
                onChange={(e) => {
                  const [year, month, day] = e.target.value.split('-').map(Number);
                  const localDate = new Date(year, month - 1, day);
                  form.setFieldValue(props.name, localDate.toLocaleDateString());
                }}
                onBlur={field.onBlur}
                spellCheck={false}
                className="mobile-native-date-input"
              />
              {hasError && (
                <div className="error-message">
                  {meta.error}
                </div>
              )}
            </div>
          );
        }}
      </Field>
    );
  }

  return <DatePicker {...props} />;
}
